module.exports = __webpack_public_path__ + "static/media/waichu.d5944f0d.png";